export default {
  UNKNOWN: 'UNKNOWN',
};
